<template>
  <v-container grid-list-lg v-if="organisasi" class="pa-5 background">
    <m-page-guide
      :steps="steps"
      :show="showGuide"
      action="toBantuan"
      @toBantuan="toBantuan"
      exit="exit"
    />

    <v-row wrap v-show="organisasi">
      <v-col cols="12">
        <m-card
          :title="label ? 'Profil ' + label : 'Profil Organisasi'"
          :edit="isCan('organisasi.update')"
          @edit="edit"
          :setting="isCan('pengaturan.update')"
          @setting="settingDefault"
        >
          <v-row wrap>
            <v-col cols="12" sm="6" md="6">
              <v-card text color="#009688" flat>
                <v-img
                  class="white--text"
                  height="250px"
                  src="img/parallax.png"
                >
                  <v-container fill-height container--fluid>
                    <v-row fill-height>
                      <v-col class="text-center" cols="12" align-end colbox>
                        <v-avatar :size="200" color="grey lighten-4">
                          <img
                            :src="
                              organisasi && organisasi.file_foto
                                ? organisasi.file_foto
                                : 'img/organisasi-default.png'
                            "
                            alt="avatar"
                          />
                        </v-avatar>
                        <div
                          class="card-footer text-muted"
                          v-html="message"
                        ></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-img>
                <v-btn
                  v-show="isCan('organisasi.update')"
                  icon
                  large
                  color="white"
                  style="position: absolute;right: 0px;top: 5px;"
                  id="pick-avatar"
                >
                  <v-icon>mdi-camera</v-icon>
                </v-btn>
                <avatar-cropper
                  :upload-handler="cropperHandler"
                  trigger="#pick-avatar"
                  :output-mime="cropperOutputMime"
                  :output-quality="0.8"
                  :output-options="{ width: 400, height: 400 }"
                  :labels="{ submit: 'Simpan', cancel: 'Hapus' }"
                />
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-list class="pt-0">
                <m-list-tile-info
                  label="Kode Tenant"
                  :value="pVal(organisasi.tenants, 'no_reg')"
                />
                <m-list-tile-info
                  label="Kode Organisasi"
                  :value="pVal(organisasi, 'kode_organisasi')"
                />
                <m-list-tile-info
                  label="Nama Organisasi"
                  :value="pVal(organisasi, 'nama')"
                />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Berakhir Berlangganan</v-list-item-subtitle
                    >
                    <slot name="value">
                      <span class="subtitle-1 font-weight-bold red--text">
                        {{
                          organisasiAktif.tgl_berlaku_akhir | toDT
                        }}
                        {{ itemZonaWaktu[current_konfigurasi.timezone] || 'WIB' }}
                      </span>
                    </slot>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-list>
                <v-subheader class="title primary--text">Kontak</v-subheader>
                <v-divider></v-divider>
                <m-list-tile-info label="Alamat" :value="organisasi.alamat" />
                <m-list-tile-info
                  label="No. Telepon"
                  :value="organisasi.no_telp"
                />
                <m-list-tile-info label="Surel" :value="organisasi.email" />
                <m-list-tile-info label="Fax" :value="organisasi.fax" />
              </v-list>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-list>
                <v-subheader class="title primary--text"
                  >Informasi Tambahan</v-subheader
                >
                <v-divider></v-divider>
                <span v-for="item of organisasi.atribut" :key="item.key">
                  <m-list-tile-info :label="item.key" :value="item.value" />
                </span>
              </v-list>
            </v-col>
            <v-col id="konfigurasiorganisasi" cols="12" sm="6" md="6" lg="6">
              <v-list v-if="setting">
                <v-subheader class="title primary--text"
                  >Konfigurasi Organisasi</v-subheader
                >
                <v-divider></v-divider>
                <m-list-tile-info
                  v-if="setting.konfigurasi.timezone"
                  label="Zona Waktu"
                  :value="
                    setting.konfigurasi.timezone == 'Asia/Jakarta'
                      ? 'WIB'
                      : setting.konfigurasi.timezone == 'Asia/Makassar'
                      ? 'WITA'
                      : 'WIT'
                  "
                />
                <m-list-tile-info
                  label="Menggunakan Penjadwalan di Masook"
                  :value="
                    setting.konfigurasi.is_jadwal_disable ? 'Tidak' : 'Ya'
                  "
                />
                <m-list-tile-info
                  label="Perhitungan Skor Kehadiran Presensi"
                  :value="
                    setting.konfigurasi.aturan_presensi_2x ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Aktifkan Pencarian Identitas menggunakan QRCode"
                  :value="
                    setting && setting.konfigurasi.is_qrcode ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Aktifkan Pencatatan Aktivitas setelah presensi"
                  :value="
                    setting && setting.konfigurasi.is_activity ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Pengguna Wajib Mengisi Aktivitas"
                  :value="
                    setting && setting.konfigurasi.is_sequential_activity
                      ? 'Ya'
                      : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Batas Perubahan Data"
                  :value="
                    setting.konfigurasi.tanggal_batas_ubah
                      ? 'Tanggal ' +
                        setting.konfigurasi.tanggal_batas_ubah +
                        ' Bulan berikutnya'
                      : 'Tidak dibatasi'
                  "
                />
                <m-list-tile-info
                  label="Notifikasi Ketidakhadiran"
                  :value="
                    setting.konfigurasi&&setting.konfigurasi.notifikasi_ketidakhadiran == true
                      ? 'Aktif': 'Non Aktif'
                  "
                />
              </v-list>
            </v-col>
            <v-col
              id="konfigurasiperangkatpengguna"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <v-list v-if="setting">
                <v-subheader class="title primary--text"
                  >Konfigurasi Perangkat Pengguna</v-subheader
                >
                <v-divider></v-divider>
                <m-list-tile-info
                  label="Presensi Perangkat Pengguna"
                  :value="
                    setting && setting.konfigurasi.gawai_pribadi
                      ? 'Ya'
                      : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Gunakan Lokasi Presensi"
                  :value="
                    setting && setting.konfigurasi.is_radius ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Perekaman Wajah Jarak Jauh (Menggunakan Perangkat Pengguna)"
                  :value="
                    setting && setting.konfigurasi.remote_enrolled
                      ? 'Ya'
                      : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Aturan Tidak Menggunakan Apps Instansi pada Instansi"
                  :value="
                    setting && setting.konfigurasi.is_mobile_instansi ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Penggunaan Masook di Sistem Operasi iOS (Perangkat Apple)"
                  :value="
                    setting && setting.konfigurasi.is_mobile_ios ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Gunakan Jenis Kondisi Presensi Sebelum Presensi"
                  :value="
                    setting && setting.konfigurasi.opsi_tipe_presensi ? 'Ya' : 'Tidak'
                  ">
                  <template v-slot:value>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="font-weight-normal">
                          {{ setting && setting.konfigurasi.opsi_tipe_presensi ? 'Ya' : 'Tidak' }}
                          <v-icon v-if="setting && setting.konfigurasi.opsi_tipe_presensi" small right color="primary" v-on="on" v-bind="attrs">mdi-information</v-icon>
                        </span>
                      </template>
                      <div class="mx-3 caption" v-for="item in setting.konfigurasi.tipe_presensi" :key="item.key">
                        <div v-if="item.is_visible"> <strong>{{ item.status }}:</strong> {{ item.deskripsi || '' }}</div>
                      </div>
                    </v-tooltip>
                  </template>
                </m-list-tile-info>
                <m-list-tile-info
                  label="Aturan Registrasi ( Pairing ) Perangkat Instansi Lebih dari Satu"
                  :value="
                    setting && setting.konfigurasi.is_multi_perangkat_instansi ? 'Ya' : 'Tidak'
                  "
                />
                <m-list-tile-info
                  label="Kondisi Presensi Dimunculkan pada Laporan"
                  :value="
                    setting && setting.konfigurasi.laporan_status_hadir ? 'Ya' : 'Tidak'
                  "
                />
              </v-list>
            </v-col>
            <v-col
              v-if="current_user.is_admin !== 1"
              id="infokuota"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <v-list>
                <v-subheader class="title primary--text">Informasi Kuota</v-subheader>
                <v-divider></v-divider>
                <m-list-tile-info
                  label="Total Kuota"
                  :value="(organisasi && organisasi.kuota) || ''"
                />
              </v-list>
            </v-col>
          </v-row>
          <v-row id="lokasipresensi" v-show="$consts.GMAP_KEY">
            <v-col
              cols="12"
              md="12"
              :class="{ 'pt-5': $vuetify.breakpoint.mdAndUp }"
              :style="$vuetify.breakpoint.smAndDown ? 'min-height:350px' : ''"
            >

              <span class="title primary--text">Lokasi Presensi</span>
              <v-card class="pa-5 mt-3" height="350" outlined tile>
                <template>
                  <GmapMap
                    :center="center"
                    map-type-id="terrain"
                    :zoom="17"
                    :options="{
                      scaleControl: true,
                      fullscreenControl: true,
                      controlSize: 25
                    }"
                    style="width: 100%; height: 300px"
                  >
                    <gmap-info-window
                      :options="infoOptions"
                      :position="infoWindowPos"
                      :opened="infoWinOpen"
                      @closeclick="infoWinOpen = false"
                    ></gmap-info-window>
                    <GmapMarker
                      v-for="(item, index) in markers"
                      :key="index"
                      :clickable="true"
                      @click="toggleInfoWindow(item, index)"
                      :position="getPosition(item)"
                    />
                    <GmapCircle
                      v-for="pin in markers"
                      :key="pin.latitude"
                      :center="pin.position"
                      :radius="pin.position.radius"
                      :visible="true"
                      :options="{
                        fillColor: 'red',
                        fillOpacity: 0.3,
                        strokeOpacity: 0.1,
                        strokeWeight: 0.5
                      }"
                    ></GmapCircle>
                  </GmapMap>
                </template>
              </v-card>
            </v-col>
            <v-col id="konfigurasilokasi" cols="12" sm="12" md="12" lg="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Nama</th>
                      <th class="text-left">Lokasi</th>
                      <th class="text-left">Latitude</th>
                      <th class="text-left">Longitude</th>
                      <th class="text-left">Radius</th>
                      <th class="text-left">Status</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="lokasi in organisasi.lokasi_presensis"
                      :key="lokasi.lokasi_presensi_id"
                    >
                      <td>{{ pVal(lokasi, "nama") }}</td>
                      <td>{{ pVal(lokasi, "alamat") }}</td>
                      <td>{{ pVal(lokasi, "latitude") }}</td>
                      <td>{{ pVal(lokasi, "longitude") }}</td>
                      <td>{{ pVal(lokasi, "radius") }}</td>
                      <td>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-chip v-on="on" outlined dark small :color="lokasi && lokasi.k_status === 2 ? 'red' : 'success'">
                              <v-icon left small>{{ lokasi && lokasi.k_status === 2 ? 'mdi-close' : 'mdi-check' }}</v-icon>
                              {{ lokasi && lokasi.k_status === 2 ? 'Tidak Aktif' : 'Aktif' }}
                            </v-chip>
                          </template>
                          <span>{{ lokasi && lokasi.k_status === 2 ? 'Lokasi Tidak Aktif' : 'Lokasi Aktif' }}</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <m-menu
                          v-if="isCan('pengaturan.update')"
                          :disabled="current_organisasi&&!current_organisasi.is_langganan"
                          left
                          style="float:right"
                          :items="more_menu"
                          :object="lokasi"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn
                v-show="isCan('pengaturan.update')"
                depressed
                :disabled="current_organisasi&&!current_organisasi.is_langganan"
                color="primary white--text ma-2"
                @click="addLokasi"
              >
                <v-icon>mdi-plus</v-icon>Tambah lokasi
              </v-btn>
            </v-col>
          </v-row>
          <br />
        </m-card>
        <div class="text-right">
          <v-btn
            v-show="isCan('organisasi.destroy') && !is_disable"
            depressed
            class="text-right"
            color="red white--text ma-2"
            @click="hapus(organisasi)"
          >
            <v-icon>mdi-trash</v-icon>Hapus Organisasi
          </v-btn>
        </div>
      </v-col>
      <component
        :is="current_user.is_admin === 1 ? 'FormAdmin' : 'ChangeDlg'"
        :tenant="{}"
        ref="dlg"
      />
      <SettingDefault ref="dlgSetting" />
      <LokasiDlg ref="dlgLokasi" />
    </v-row>
  </v-container>
</template>
<script>
import { BANTUAN } from "@/const";
import moment from "moment";
import { isCan } from "@/tools";
import AvatarCropper from "vue-avatar-cropper";
import ChangeDlg from "../components/Form.vue";
import FormAdmin from "../components/FormAdmin";
import SettingDefault from "../components/FormSetting.vue";
import LokasiDlg from "../components/FormLokasi.vue";

const lc = window.localStorage;
const GUIDE = "GUIDE";

export default {
  components: {
    AvatarCropper,
    ChangeDlg,
    SettingDefault,
    LokasiDlg,
    FormAdmin,
  },
  data() {
    return {
      message: "",
      showGuide: false,
      organisasi: null,
      setting: null,
      statusLangganan: false,
      lokasiTerpilih: null,
      center: { lat: -6.175147, lng: 106.827207 },
      cropperOutputMime: null,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      steps: [
        {
          element: "#settingkonfigurasi",
          intro:
            "Langkah selanjutnya Anda diharuskan melakukan <b>Konfigurasi Organisasi</b> terkait jadwal, konfigurasi umum dan <b>Konfigurasi Penggunaan Perangkat pengguna</b>.",
          position: "left"
        },
        {
          element: "#konfigurasiorganisasi",
          intro:
            "Hasil Konfigurasi <b>Konfigurasi Organisasi</b> yang telah ditentukan dapat dilihat pada kolom ini.",
          position: "bottom"
        },
        {
          element: "#konfigurasiperangkatpengguna",
          intro:
            "Hasil Konfigurasi <b>Konfigurasi Perangkat Pengguna</b> yang telah ditentukan dapat dilihat pada kolom ini."
        },
        {
          element: "#konfigurasilokasi",
          intro:
            "Selanjutnya jika organisasi atau instansi Anda menggunakan presensi pada lokasi tertentu, Anda bisa menambahkan lokasi yang diinginkan pada menu ini. </br> Untuk bantuan lebih lanjut Anda dapat klik tombol Bantuan berikut."
        }
      ],

      more_menu: [
        {
          title: "Cek Titik Lokasi",
          click: (i, o) => this.setCenter(o)
        },
        {
          title: "Ubah",
          click: (i, o) => this.editLokasi(o),
          check: () => isCan("pengaturan.update")
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapusLokasi(o),
          check: () => isCan("pengaturan.update")
        },
        {
          title: "Aktifkan",
          click: (i, o) => this.statusLokasi(o),
          check: (i, o) =>
            isCan('lokasi-presensi.set-status') &&
            Number(o.k_status || 1) === 2
        },
        {
          title: "Non-Aktifkan",
          click: (i, o) => this.statusLokasi(o),
          check: (i, o) =>
            isCan('lokasi-presensi.set-status') &&
            Number(o.k_status || 1) === 1
        }
      ],

      itemZonaWaktu: {
        'Asia/Jakarta': 'WIB',
        'Asia/Makassar': 'WITA',
        'Asia/Jayapura': 'WIT'
      }
    };
  },
  computed: {
    organisasiAktif() {
      return this.$store.getters["organisasi/organisasiAktif"];
    },
    markers() {
      const lokasis = [];
      this.organisasi.lokasi_presensis.forEach(lokasi => {
        const a = {
          position: {
            lat: parseFloat(lokasi.latitude),
            lng: parseFloat(lokasi.longitude),
            radius: parseFloat(10)
          },
          lat: parseFloat(lokasi.latitude),
          lng: parseFloat(lokasi.longitude),
          radius: parseFloat(10),
          infoText: "<b>" + lokasi.nama + "</b>"
        };
        lokasis.push(a);
      });
      return lokasis;
    },
    label() {
      return "Instansi";
    }
  },
  mounted() {
    moment.locale("id");
    this.message = "";

    this.load();
  },
  activated() {
    setTimeout(() => {
      if (this.$route.query && this.$route.query && this.$route.query.mode === 'popup') {
        this.settingDefault()
      }
    }, 1000);
  },
  methods: {
    getPosition: function(marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      };
    },

    checkGuide() {
      var check = lc.getItem(GUIDE);
      if (typeof check == "undefined" || check == null) {
        lc.setItem(GUIDE, true);
        this.showGuide = true;
      } else {
        this.showGuide = check == "true" ? true : false;
      }
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    addLokasi() {
      this.$refs.dlgLokasi.open().then(() => {
        this.load();
      });
    },
    editLokasi(item) {
      this.$refs.dlgLokasi.open(item).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    load() {
      if (this.organisasi_id)
        this.$store
          .dispatch("organisasi/detail", this.organisasi_id)
          .then(res => {
            this.page = res.data;
            this.organisasi = res.data;

            this.setCenter();

            if (res.data.file_foto)
              this.organisasi.file_foto = res.data.file_foto;
          })
          .then(() => {
            this.$nextTick(() => {
              this.checkGuide();
            });
            this.loadSetting();
          })
          .catch(e => e);
    },
    toBantuan() {
      lc.setItem("GUIDE", false);
      window.open(BANTUAN, "_blank");
    },
    setCenter(data) {
      this.center.radius = this.setting ? this.setting.konfigurasi.radius : 0;
      if (
        this.organisasi &&
        this.organisasi.lokasi_presensis.length > 0 &&
        !data
      ) {
        this.center.lat = parseFloat(
          this.organisasi.lokasi_presensis[0].latitude
        );
        this.center.lng = parseFloat(
          this.organisasi.lokasi_presensis[0].longitude
        );
      } else if (
        this.organisasi &&
        this.organisasi.lokasi_presensis.length > 0 &&
        data
      ) {
        this.center.lat = parseFloat(data.latitude);
        this.center.lng = parseFloat(data.longitude);
      } else {
        this.center = { lat: -6.175147, lng: 106.827207 };
      }
    },

    cropperHandler(cropper) {
      var imgdat = cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime);
      var file = this.dataURLtoFile(imgdat, "test.png");
      var original = this.dataURLtoFile(cropper.crossOriginUrl, 'img.png')

      var size = (original.size / (1024)).toFixed(2)
      if (size > 1500) {
        this.$error('File logo maksimal 1.5MB')
        return
      } else {
        this.$store
          .dispatch("organisasi/uploadImage", {
            organisasi_id: this.organisasi_id,
            data: file
          })
          .then(() => {
            this.load();
          })
          .catch(e => e);
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // eslint-disable-next-line
    loadSetting() {
      this.$store
        .dispatch("organisasi/cekSetting", this.organisasi_id)
        .then(res => {
          this.setting = res.data.data;
          res.data.data ? Promise.resolve : this.cekSettingDefault();
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    edit() {
      this.$refs.dlg.open(this.organisasi).then(() => {
        this.load();
      });
    },
    logout() {
      this.$store
        .dispatch("user/logout")
        .then(() => {
          this.$store.commit("main/setHsidebar", false, {
            root: true
          });
          this.$store.commit("main/setLDrawer", false, {
            root: true
          });
          this.$router.push({ name: "login" });
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    cekSettingDefault() {
      this.$confirmDanger(
        `Anda belum melakukan Konfigurasi Default untuk organisasi ini. Setting sekarang?<br>
      `
      ).then(() =>
        this.$refs.dlgSetting.open(this.organisasi).then(() => {
          this.load();
        })
      );
    },
    // eslint-disable-next-line
    settingDefault() {
      this.$refs.dlgSetting.open(this.organisasi).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    hapus(item) {
      this.$confirmDanger(
        `
         <div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
          Anda juga akan menghapus seluruh anggota di organisasi ini!
          </div>
        </div>

        Apakah Anda yakin akan menghapus Organisasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>

      `
      )
        .then(() => {
          return this.$store.dispatch("organisasi/drop", item.kode_organisasi);
        })
        .then(res => {
          if (res.code == 200) {
            this.$info("Hapus Organisasi berhasil");
            this.$router.push({ name: "organisasi.pilih" });
            this.$refs.dlg.resolve();
            return res;
          } else {
            this.$error("Hapus Organisasi Gagal");
            this.$refs.dlg.resolve();
            // this.$router.push({ name: "organisasi.pilih" });
          }
        })
        .catch(e => e);
    },
    hapusLokasi(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan menghapus lokasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
      `
      )
        .then(() => {
          this.$store
            .dispatch("organisasi/dropLokasi", {
              organisasi_id: this.organisasi_id,
              lokasi: item
            })
            .then(res => {
              this.load();
              this.$info("Hapus Lokasi berhasil");
              return res;
            });
        })
        .then(() => {
          this.$refs.dlg.resolve();
        })
        .catch(e => e);
    },
    statusLokasi(item) {
      const labels = {
        title: item && item.k_status === 2 ? 'Aktifkan' : 'Non-Aktifkan',
        color: item && item.k_status === 2 ? 'blue' : 'red'
      }
      this.$confirmDanger(
        `Apakah Anda yakin akan ${labels.title} lokasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
      `
      )
        .then(() => {
          this.$store.dispatch('organisasi/statusLokasi',
            {
              organisasi_id: this.organisasi_id,
              lokasi: {
                lokasi_presensi_id: item.lokasi_presensi_id,
                params: {
                  k_status: item && item.k_status === 2 ? 1 : 2
                }
              }
            }
          ).then((res) => {
            this.load()
            this.$info(`Lokasi berhasil di ${labels.title}`);
            return res
          })
        })
        .then(() => {
          this.$refs.dlg.resolve();
        })
        .catch(e => e);
    }
  },
  watch: {
    organisasi_id(n) {
      if (typeof n !== "undefined") this.load();
    }
  }
};
</script>
